<template>
  <div @keydown.enter="$emit('search')">
    <b-card no-body class="mb-3 w-100 z-index-sticky position-relative">
      <b-card-header
        header-tag="header"
        class="p-1 bg-transparent d-inline-flex align-items-center border-0"
        role="tab"
      >
        <h5 class="mb-0">Filtros gerais</h5>
      </b-card-header>
      <b-collapse v-model="isGeneralFilters" visible>
        <b-card-body>
          <b-row>
            <b-form-group
              label="Código"
              class="col-12 col-md-6 col-lg-3 col-xl-3"
            >
              <div class="position-relative">
                <b-form-input
                  v-model="modelValue.codigo"
                  trim
                  placeholder="Ex.: 123"
                />
                <clear-button
                  :display="hasFieldValue('codigo')"
                  @click="clearField('codigo')"
                />
              </div>
              <b-form-text>
                Use * para ampliar a busca por código.
                <b-button
                  id="hint-asterisc-search"
                  variant="link"
                  class="p-0"
                  size="sm"
                >
                  Saiba mais.
                </b-button>
                <b-popover
                  ref="hint"
                  target="hint-asterisc-search"
                  triggers="hover"
                  placement="bottom"
                  custom-class="popover-hint-search"
                >
                  <template #title>Como usar * e # na busca</template>
                  <hint-asterisc-search
                    @done="doneHint"
                    @apply="applySugestionHint"
                  />
                </b-popover>
              </b-form-text>
            </b-form-group>
            <b-form-group label="Nome" class="col-12 col-md-6 col-lg-4 col-xl">
              <div class="position-relative">
                <b-form-input
                  v-model="modelValue.nome"
                  trim
                  placeholder="Ex.: Política de Patrocínio"
                />
                <clear-button
                  :display="hasFieldValue('nome')"
                  @click="clearField('nome')"
                />
              </div>
            </b-form-group>
            <b-form-group
              label="Concedente"
              class="col-12 col-md-6 col-lg-4 col-xl"
            >
              <div class="position-relative">
                <select-concedente
                  v-model="modelValue.concedente_id"
                  placeholder="Concedente..."
                />
                <clear-button
                  :display="hasFieldValue('concedente_id')"
                  @click="clearField('concedente_id')"
                />
              </div>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group
              label="Categoria"
              class="col-12 col-md-6 col-lg-4 col-xl-3"
            >
              <div class="position-relative">
                <b-form-select
                  v-model="modelValue.categorias"
                  text-field="nome"
                  value-field="id"
                  :options="listCategorias"
                  :data-clear="hasFieldValue('categorias')"
                />
                <clear-button
                  :display="hasFieldValue('categorias')"
                  @click="clearField('categorias')"
                />
              </div>
            </b-form-group>
            <b-form-group
              label="Prazos"
              class="col-12 col-md-6 col-lg-4 col-xl"
            >
              <div class="position-relative">
                <b-form-select
                  v-model="modelValue.prazo"
                  text-field="label"
                  value-field="value"
                  :options="listPrazos"
                  :data-clear="hasFieldValue('prazo')"
                />
                <clear-button
                  :display="hasFieldValue('prazo')"
                  @click="clearField('prazo')"
                />
              </div>
            </b-form-group>
            <b-form-group
              label="Disponibilidade"
              class="col-12 col-md-6 col-lg-4 col-xl"
            >
              <div class="position-relative">
                <b-form-select
                  v-model="modelValue.disponibilidade"
                  text-field="label"
                  value-field="value"
                  :options="listDisponibilidades"
                  :data-clear="hasFieldValue('disponibilidade')"
                />
                <clear-button
                  :display="hasFieldValue('disponibilidade')"
                  @click="clearField('disponibilidade')"
                />
              </div>
            </b-form-group>
          </b-row>

          <card-collapse-filter
            icon="calendar-days"
            title="Períodos"
            description="Filtre oportunidades por intervalos de datas importantes."
            class="bg-periods"
            :initial-visible="false"
          >
            <template #right="{ visible }">
              <small
                v-if="labelActiveFilters('periods') && !visible"
                class="text-white bg-exitos rounded-pill px-2 py-1 mr-3"
                v-text="labelActiveFilters('periods')"
              />
            </template>
            <wrapper-period-group
              :icon="['regular', 'calendar']"
              title="Criadas entre"
              description="Data em que a oportunidade foi criada"
              class="mb-3"
            >
              <b-form-group
                label="Data inicial"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.created_start"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
              <div
                class="col-auto pb-3 d-inline-flex align-items-end text-muted"
              >
                <font-awesome-icon icon="minus" />
              </div>
              <b-form-group
                label="Data final"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.created_end"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
            </wrapper-period-group>
            <wrapper-period-group
              icon="arrows-rotate"
              title="Atualizadas entre"
              description="Data da última atualização da oportunidade"
              class="mb-3"
            >
              <b-form-group
                label="Data inicial"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.update_start"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
              <div
                class="col-auto pb-3 d-inline-flex align-items-end text-muted"
              >
                <font-awesome-icon icon="minus" />
              </div>
              <b-form-group
                label="Data final"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.update_end"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
            </wrapper-period-group>
            <wrapper-period-group
              :icon="['regular', 'paper-plane']"
              title="Disponibilizadas entre"
              description="Data em que a oportunidade foi disponibilizada"
              class="mb-3"
            >
              <b-form-group
                label="Data inicial"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.available_start"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
              <div
                class="col-auto pb-3 d-inline-flex align-items-end text-muted"
              >
                <font-awesome-icon icon="minus" />
              </div>
              <b-form-group
                label="Data final"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.available_end"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
            </wrapper-period-group>
            <wrapper-period-group
              icon="file-signature"
              title="Propostas abertas entre"
              description="Período em que as propostas recebem inscrições"
              class="mb-3"
            >
              <b-form-group
                label="Data inicial"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.proposta_ini_start"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
              <div
                class="col-auto pb-3 d-inline-flex align-items-end text-muted"
              >
                <font-awesome-icon icon="minus" />
              </div>
              <b-form-group
                label="Data final"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.proposta_ini_end"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
            </wrapper-period-group>
            <wrapper-period-group
              :icon="['solid', 'hourglass-end']"
              title="Encerramento das propostas"
              description="Data limite para submissão das propostas"
            >
              <b-form-group
                label="Data inicial"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.proposta_fim_start"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
              <div
                class="col-auto pb-3 d-inline-flex align-items-end text-muted"
              >
                <font-awesome-icon icon="minus" />
              </div>
              <b-form-group
                label="Data final"
                class="col-12 col-md-5 col-lg-4 mb-0"
              >
                <date-input
                  input-class="form-control"
                  v-model="modelValue.proposta_fim_end"
                  format="dd/MM/yyyy"
                />
              </b-form-group>
            </wrapper-period-group>
          </card-collapse-filter>

          <card-collapse-filter
            icon="tags"
            title="Classificação"
            description="Refine a busca por qualificação, natureza jurídica e área."
            class="bg-periods"
            :initial-visible="false"
          >
            <template #right="{ visible }">
              <small
                v-if="labelActiveFilters('classification') && !visible"
                class="text-white bg-exitos rounded-pill px-2 py-1 mr-3"
                v-text="labelActiveFilters('classification')"
              />
            </template>
            <b-row class="py-4 px-0 mb-3">
              <b-form-group
                label="Qualificação da Proposta"
                class="col-12 col-md-6 col-lg-4 col-xl-3"
              >
                <div class="position-relative">
                  <b-form-select
                    v-model="modelValue.qualificacao_proposta"
                    :options="qualificacao_proposta"
                    :data-clear="hasFieldValue('qualificacao_proposta')"
                  />
                  <clear-button
                    :display="hasFieldValue('qualificacao_proposta')"
                    @click="clearField('qualificacao_proposta')"
                  />
                </div>
              </b-form-group>
              <b-col>
                <b-form-group label="Natureza jurídica">
                  <tree-select
                    v-model="modelValue.natureza_juridica"
                    multiple
                    placeholder="Ex.: Administração..."
                    :options="tiposInstituicoes"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Áreas da oportunidade">
                  <select-area v-model="modelValue.areas" :multiple="true" />
                </b-form-group>
              </b-col>
            </b-row>
          </card-collapse-filter>

          <card-collapse-filter
            :icon="['regular', 'map']"
            title="Localidade"
            description=" Filtre por estados, municípios ou internacional"
            class="bg-periods"
          >
            <template #right="{ visible }">
              <small
                v-if="labelActiveFilters('location') && !visible"
                class="text-white bg-exitos rounded-pill px-2 py-1 mr-3"
                v-text="labelActiveFilters('location')"
              />
            </template>
            <b-row class="py-4 px-0 mb-3">
              <b-form-group class="col-12">
                <label
                  class="border cursor-pointer bg-white rounded-3 p-3 pt-3 d-inline-flex w-100 overflow-hidden mb-0"
                >
                  <b-form-checkbox
                    v-model="modelValue.nacionalidade"
                    name="nacionalidade"
                    value="internacional"
                    class="mr-auto cursor-pointer"
                    switch
                  >
                    <h6 class="h5 cursor-pointer font-weight-bold mb-0">
                      Abrangência internacional
                    </h6>
                    <p class="cursor-pointer small text-muted mb-0">
                      Oportunidades sem vínculo com estados ou municípios
                      brasileiros.
                    </p>
                  </b-form-checkbox>
                </label>
              </b-form-group>
              <b-form-group label="Estados" class="col-12">
                <select-multi-estado
                  v-model="modelValue.estado"
                  :disabled="disabledNationalFields"
                />
              </b-form-group>
              <b-form-group label="Municípios" class="col-12">
                <select-multi-municipio
                  v-model="modelValue.municipio"
                  :disabled="disabledNationalFields"
                />
              </b-form-group>
            </b-row>
          </card-collapse-filter>

          <card-collapse-filter
            icon="sack-dollar"
            title="Valores"
            description="Filtre por moeda e faixas de valor"
            class="bg-periods"
          >
            <template #right="{ visible }">
              <small
                v-if="labelActiveFilters('values') && !visible"
                class="text-white bg-exitos rounded-pill px-2 py-1 mr-3"
                v-text="labelActiveFilters('values')"
              />
            </template>
            <b-row class="py-4 px-0 mb-3">
              <b-form-group label="Moeda" class="col-12 col-md-4 col-lg-3">
                <div class="position-relative">
                  <select-moeda v-model="modelValue.moeda_id" />
                  <clear-button
                    :display="hasFieldValue('moeda_id')"
                    @click="clearField('moeda_id')"
                  />
                </div>
              </b-form-group>
              <b-form-group
                label="Valores por projeto"
                class="col-12 col-md-4 col-lg"
              >
                <div class="position-relative">
                  <number-format
                    v-model="modelValue.valor_projeto_min"
                    placeholder="R$ 0,00"
                  />
                  <clear-button
                    :display="hasFieldValue('valor_projeto_min')"
                    @click="clearField('valor_projeto_min')"
                  />
                </div>
              </b-form-group>
              <b-form-group
                label="Valores Totais"
                class="col-12 col-md-4 col-lg"
              >
                <div class="position-relative">
                  <number-format
                    v-model="modelValue.valor_total_min"
                    placeholder="R$ 1.000.000,00"
                  />
                  <clear-button
                    :display="hasFieldValue('valor_total_min')"
                    @click="clearField('valor_total_min')"
                  />
                </div>
              </b-form-group>
            </b-row>
          </card-collapse-filter>

          <card-collapse-filter
            icon="globe"
            title="ODS"
            description="Filtre por objetivos de desenvolvimento sustentável"
            class="bg-periods"
          >
            <template #right="{ visible }">
              <small
                v-if="labelActiveFilters('ods') && !visible"
                class="text-white bg-exitos rounded-pill px-2 py-1 mr-3"
                v-text="labelActiveFilters('ods')"
              />
            </template>
            <b-row class="py-4 px-0 mb-3">
              <b-form-group label="Objetivos ODS" class="col-12">
                <select-ods v-model="modelValue.ods" />
              </b-form-group>
            </b-row>
          </card-collapse-filter>
        </b-card-body>
      </b-collapse>
      <div ref="endContent" class="end-content w-100 position-relative"></div>
      <div :class="footerClass" class="w-100">
        <b-card-footer class="d-inline-flex align-items-center w-100">
          <span
            v-if="total && !loading"
            v-html="labelTotalItems"
            class="text-muted text-sm"
          />
          <b-button
            @click="$emit('clear')"
            class="ml-auto"
            variant="outline-exitos"
            :disabled="!countItemsByKey('all')"
          >
            Limpar filtros
          </b-button>
          <b-button
            @click="$emit('search')"
            variant="exitos"
            :disabled="loading"
          >
            <font-awesome-icon v-show="loading" icon="spinner" spin-pulse />
            Aplicar filtros
          </b-button>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import DateInput from "@/components/Form/DateInput.vue";
import NumberFormat from "@/components/Form/NumberFormat.vue";
import SelectMoeda from "@/modules/moedas/Components/SelectMoeda.vue";
import SelectMultiEstado from "@/modules/municipios/Components/SelectMultiEstado";
import SelectMultiMunicipio from "@/modules/municipios/Components/SelectMultiMunicipio";
import SelectOds from "@/components/Form/SelectOds.vue";
import SelectArea from "@/modules/areas/Components/SelectArea.vue";
import CardCollapseFilter from "@/modules/oportunidades/Components/CardCollapseFilter.vue";
import WrapperPeriodGroup from "@/modules/oportunidades/Components/WrapperPeriodGroup.vue";
import ClearButton from "@/modules/oportunidades/Components/ClearButton.vue";
import HintAsteriscSearch from "@/modules/oportunidades/Components/HintAsteriscSearch.vue";
import SelectConcedente from "@/modules/oportunidades/Components/SelectConcedente.vue";
import { listPrazos } from "@/modules/oportunidades/constants/listPrazos";
import { listDisponibilidades } from "@/modules/oportunidades/constants/listDisponibilidades";
import { isSafeArray, safeArray, size } from "@/helpers/functions/ArrayHelpers";
import { toggleValue } from "@/mixins/toggle";
import { isVisible } from "@/mixins/isVisible";
import {
  filterGroups,
  formEmptyDefault,
} from "@/modules/oportunidades/constants/formEmptyDefault";
import { deepCopy } from "@/helpers/functions/ObjectHelpers";
import { modelValue } from "@/mixins/modelValue";
import pretty_number from "@/helpers/filters/pretty_number";

export default {
  name: "BuscaAvancada",
  components: {
    CardCollapseFilter,
    ClearButton,
    DateInput,
    NumberFormat,
    SelectArea,
    SelectMoeda,
    HintAsteriscSearch,
    SelectMultiEstado,
    SelectMultiMunicipio,
    SelectConcedente,
    SelectOds,
    WrapperPeriodGroup,
  },
  props: {
    value: {
      type: Object,
      default: formEmptyDefault,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  emits: ["clear", "search"],
  mixins: [
    modelValue("value", "input"),
    toggleValue("general filters", {
      initialValue: true,
      falseValue: false,
      trueValue: true,
    }),
    isVisible("endContent"),
  ],
  data: () => ({
    tiposInstituicoes: [],
    tiposInstrumentos: [],
  }),
  computed: {
    ...mapState("categorias", ["categorias"]),
    ...mapGetters("oportunidades", ["qualificacao_proposta"]),
    labelTotalItems() {
      const suffix = this.total === 1 ? "" : "s";
      const total = pretty_number(this.total);

      return `<strong>${total}</strong> Resultado${suffix} encontrado${suffix}`;
    },
    listCategorias() {
      return [
        { nome: "Selecionar categoria...", id: null, disabled: true },
        ...safeArray(this.categorias),
      ];
    },
    listPrazos() {
      return listPrazos;
    },
    disabledNationalFields() {
      return !!size(this.modelValue.nacionalidade);
    },
    listDisponibilidades() {
      return listDisponibilidades;
    },
    footerClass() {
      if (!this.isEndcontentVisible) {
        return "fixed-footer-custom";
      }

      return "static";
    },
    activeFilters() {
      const target = new Map();
      const currentForm = deepCopy(this.modelValue || {});

      for (const key in filterGroups) {
        const group = Reflect.get(filterGroups, key);
        const totalByGroup = safeArray(group)
          .filter((key) => {
            const result = Reflect.get(currentForm, key);

            if (isSafeArray(result)) return size(result) > 0;

            return !!result;
          })
          .reduce((acc) => (acc += 1), 0);

        target.set(key, totalByGroup);
      }

      return target;
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionGetAllMunicipios"]),
    ...mapActions("categorias", { getAllCategorias: "ActionGetAll" }),
    ...mapActions("oportunidades", {
      getAllTiposInstrumentos: "ActionGetTiposInstrumentos",
    }),
    ...mapActions("tipos_instituicoes", { getTiposInstituicoes: "ActionFind" }),
    size,
    hasFieldValue(key) {
      const value = Reflect.get(this.modelValue || {}, key);

      if (isSafeArray(value)) return size(value) > 0;

      return !!value;
    },
    async setTiposInstituicoes() {
      const { data } = await this.getTiposInstituicoes();
      this.tiposInstituicoes = safeArray(data).map((option) => ({
        ...option,
        label: option.nome,
        value: option.id,
        id: option.id,
      }));
    },
    async setTiposInstrumentos() {
      const tipos = await this.getAllTiposInstrumentos();
      this.tiposInstrumentos = [
        {
          value: null,
          text: "Selecione um tipo de instrumento",
        },
        ...tipos,
      ];
    },
    countItemsByKey(key) {
      if (!this.activeFilters?.has?.(key)) return 0;
      const count = this.activeFilters?.get(key) || 0;

      return count;
    },

    labelActiveFilters(key) {
      const count = this.countItemsByKey(key);

      if (count === 1) return `${count} Filtro selecionado`;
      if (count > 0) return `${count} Filtros selecionados`;

      return "";
    },
    clearField(key) {
      const cleanedField = formEmptyDefault();
      const cleanedValue = Reflect.get(cleanedField, key);

      if (Reflect.has(this.modelValue, key)) {
        this.modelValue[key] = cleanedValue;
      }
    },

    doneHint() {
      this.$refs?.hint?.doClose?.();
    },
    applySugestionHint() {
      this.modelValue = {
        ...formEmptyDefault(),
        codigo: "*26*",
      };

      this.$emit("search");

      this.$refs?.hint?.doClose?.();
    },
    async loadOptions() {
      await Promise.all([
        this.getAllCategorias({ per_page: 1000 }),
        this.setTiposInstituicoes(),
        this.setTiposInstrumentos(),
      ]);
    },
  },
  async created() {
    await this.loadOptions();
  },
};
</script>
<style scoped lang="scss">
::v-deep .col-form-label {
  font-size: 0.875rem;
  color: #525f7f;
  padding-bottom: 6px !important;
}

::v-deep .header-search {
  background: none !important;
  padding-right: 0 !important;
}

::v-deep .vue-treeselect__control {
  height: 43px;
  .vue-treeselect__placeholder,
  .vue-treeselect__single-value {
    line-height: 43px;
  }
}

.card-filter-advanced {
  & + .card-filter-advanced {
    margin-top: 1em;
  }
}

.bg-periods {
  background-color: rgba(34, 91, 115, 0.045);

  &:not(:has(.show)):hover {
    transition: background 220ms;
    background-color: rgba(34, 91, 115, 0.015);
  }
}

::v-deep .custom-select {
  &[data-clear="true"] {
    background: unset;
  }
}

.rounded-3 {
  border-radius: 0.5rem !important;
}

.fixed-footer-custom {
  z-index: 999;
  left: 0;
  bottom: 0;
  position: sticky;
  &::before {
    content: "";
    position: absolute;
    top: -4em;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 15%,
      transparent
    );
    height: 4em;
    width: 100%;
  }
}

::v-deep .date-fields {
  .form-row {
    width: 100%;
  }

  .col {
    display: inline-flex;
    flex-wrap: wrap;
    .form-control {
      width: 50%;
    }
  }
}
</style>
